import { BaseType } from '../../base/base-type';
import { RelationshipStatus } from '../../enum/shared/relationship-status';

export class RelationshipStatusType extends BaseType {
  // @ts-ignore
  public id: RelationshipStatus = 0;
}
